import { cn } from "~/utils/shadecn"
import { Separator } from "./ui/separator"
import { Link, useLocation } from "@remix-run/react"
import { useEffect, useState } from "react"
import PromotionBanner from "~/components/promotion-banner"

export interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  to?: string
  separator?: boolean
  hideBanner?: boolean
}

export interface TitleProps extends React.HTMLAttributes<HTMLDivElement> {
  content: string
  to?: string
}

export default function Header({ title, to, hideBanner, separator, className, children, ...props }: HeaderProps) {
  const [banner, setBanner] = useState(false)

  const dismissBanner = () => {
    setBanner(false)
    let expiration_date = new Date()
    expiration_date.setFullYear(expiration_date.getFullYear() + 1)
    document.cookie = "dismissBanner=wefunder; path=/; expires=" + expiration_date.toUTCString()
  }

  useEffect(() => {
    if (document.cookie.indexOf("dismissBanner=wefunder") === -1) {
      setBanner(true)
    }
  })

  return (
    <div className="mx-4 pt-0 sm:pt-4">
      {/* {!hideBanner && banner && (
        <div className="relative bg-primary/90 text-center text-zinc-50 max-w-4xl mx-auto py-1 px-2 md:py-3 md:px-4 mb-4 rounded-lg">
          <Link to="#" className="absolute top-2 right-2" onClick={dismissBanner}>
            <Cross1Icon />
          </Link>
          <Link
            to="https://wefunder.com/makelovenotporn/"
            className="text-balance hover:underline text-xs sm:text-sm"
            target="_blank">
            <b>Now you can be a small investor in MakeLoveNotPorn!</b>
            <br /> Last chance to invest in sex education for all on WeFunder. Campaign closes April 30th.
          </Link>
        </div>
      )} */}
      {!hideBanner && <PromotionBanner />}
      <div className="sm:pt-2 md:mx-6">
        <div className={cn("flex flex-wrap items-center justify-between md:space-x-4 space-y-4", className)} {...props}>
          {title && <Title content={title} to={to} />}
          {children}
        </div>
        {separator === undefined || separator ?
          <Separator className="my-4" />
        : <div className="my-4" />}
      </div>
    </div>
  )
}

export function Title({ content, className, to }: TitleProps) {
  const location = useLocation()

  return (
    <h1 className={cn("text-2xl sm:text-4xl font-black tracking-tight", className)}>
      <Link to={to ? to : `${location.pathname}${location.search}`}>{content}</Link>
    </h1>
  )
}
